import { render, staticRenderFns } from "./GroupControls.vue?vue&type=template&id=82f5faf4"
import script from "./GroupControls.vue?vue&type=script&lang=js"
export * from "./GroupControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports